import React from 'react';
import EmployeeLearning from '../../components/competency-matrix/EmployeeLearning';

const MyLearningPage = () => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <EmployeeLearning />
    </div>
  );
};

export default MyLearningPage;
